export const EXCLUSIVE = 'exclusive';
export const DEALER = 'dealer';
export const ONLINE_DEALER = 'online_dealer';
export const PRIVATE = 'private';
